import { useState, useEffect } from "react";
import "@/App.css";
import { ThemeProvider } from "next-themes";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import TrustMarquee from "@/components/landing/TrustMarquee";
import CareOptions from "@/components/landing/CareOptions";
import DoctorProfile from "@/components/landing/DoctorProfile";
import VisitInfo from "@/components/landing/VisitInfo";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import MobileCTABar from "@/components/landing/MobileCTABar";
import AppointmentModal from "@/components/landing/AppointmentModal";

function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) window.lenis = lenis;
  }, [lenis]);
  return null;
}

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <LenisBridge />
        <div className="min-h-screen bg-background font-sans text-foreground antialiased selection:bg-accent/30">
          <Header onRequest={openModal} />
          <main>
            <Hero onRequest={openModal} />
            <TrustMarquee />
            <CareOptions onRequest={openModal} />
            <DoctorProfile />
            <VisitInfo />
            <FAQ />
            <FinalCTA onRequest={openModal} />
          </main>
          <Footer />
          <div className="h-16 md:hidden" aria-hidden />
          <MobileCTABar />
          <AppointmentModal open={modalOpen} onOpenChange={setModalOpen} />
          <Toaster position="top-center" />
        </div>
      </ReactLenis>
    </ThemeProvider>
  );
}

export default App;
